import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

export function useIsOneStone() {
  const { deusExMachina } = useDeusExMachina()
  return deusExMachina?.entity.stoneAccount?.situation === 'one_stone'
}
